import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, Card, CardHeader, CardBody, Collapse, FormGroup, Label, Input } from 'reactstrap';
import { withRouter } from 'react-router';
import { Global } from '~/App';
import _ from 'underscore';
import API from '~/API';
import GriddleCasero from '~/components/GriddleCasero'
import moment from 'moment';
import InputCustomFieldForm from './InputCustomFieldForm';
import Turnstile from '~/components/Turnstile';
import RequerimientoExito from '~/components/RequerimientoExito';

const tiposRequerimientos = {}

export const CreaReiteracion = ({ evento, Servicio, anonimo, token, onExito }) => {
    const { tipo_evento } = evento || {}
    const [tipo, setTipo] = useState()
    const [abre, setAbre] = useState()
    const [folioGenerado, setFolioGenerado] = useState(null)
    const [cargando, setCargando] = useState(false)
    const [captcha, setCaptcha] = useState(null)
    const captchaRef = React.useRef()

    useEffect(() => {
        (async () => {
            if (!tiposRequerimientos.data) tiposRequerimientos.data = await API.Call(`Consulta/${Servicio.empresa}/Requerimientos/Campos/${Servicio.idServicio}`)
            const { tipos, campos } = tiposRequerimientos.data;
            const t = tipos.find(e => e.id_tipo_evento == tipo_evento);
            if (t) {
                const fullCampos = t.fieldIds.map(id => campos.find(c => c.FieldId == id));
                setTipo({ ...t, campos: fullCampos });
            }
        })()
    }, [])

    if (!tipo) return <></>

    const handleClose = () => {
        setAbre(false);
        setFolioGenerado(null);
        if (onExito && folioGenerado) {
            onExito(tipo?.comentario);
        }
    };

    const enviarReiteracion = (captchaToken) => {
        setCargando(true);
        const endpoint = anonimo 
            ? `Consulta/${Servicio.empresa}/Requerimientos/${Servicio.idServicio}/Agregar/Anonimo`
            : `Consulta/${Servicio.empresa}/Requerimientos/${Servicio.idServicio}/Agregar`;
        const payload = {
            id_evento: evento.id_evento,
            campos: [],
            comentario: tipo?.comentario
        };
        if (anonimo) {
            payload.token = token;
            if (!token && captchaToken) {
                payload.captcha = captchaToken;
            }
        }
        API.Call(endpoint, payload).then((res) => {
            setCargando(false);
            if (captchaRef.current) captchaRef.current.reset();
            setFolioGenerado(res || { Folio: 'Generado' });
        }).catch(() => {
            setCargando(false);
            if (captchaRef.current) captchaRef.current.reset();
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (anonimo && !token) {
            if (captchaRef.current) {
                captchaRef.current.execute();
            }
        } else {
            enviarReiteracion(null);
        }
    };

    return <>
        <diV className="text-right pb-2"><Button size="sm" onClick={() => setAbre(true)}>Agregar un nuevo comentario</Button></diV>

        <Modal scrollable size="lg" wrapClassName="asyntec-portal-clientes" isOpen={abre} toggle={handleClose}>
            <ModalHeader className="titulo-modal" close={<button style={{ color: "#fff" }} className="close" onClick={handleClose}>&times;</button>}>
                Agregar un nuevo Comentario
            </ModalHeader>
            <ModalBody style={{ whiteSpace: "nowrap" }}>
                {folioGenerado ? (
                    <RequerimientoExito folio={folioGenerado} onVolver={handleClose} mensajeVolver="Cerrar" />
                ) : (
                    <>
                        <FormGroup>
                            <Label className={!tipo.comentario ? "text-danger" : ""} for="desc">Comentario *</Label>
                            <Input type="textarea" name="comentario" value={tipo.comentario} onChange={e => setTipo({ ...tipo, comentario: e.target.value })} id="desc" />
                        </FormGroup>
                        {anonimo && !token && (
                            <Turnstile 
                                ref={captchaRef}
                                size="invisible"
                                sitekey={Global.apiKeyCaptcha} 
                                onChange={tokenVal => {
                                    if (tokenVal) enviarReiteracion(tokenVal);
                                }}
                                onErrored={() => setCargando(false)}
                                onExpired={() => setCargando(false)}
                            />
                        )}
                    </>
                )}
            </ModalBody>
            {!folioGenerado && (
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit} disabled={cargando || !tipo?.comentario}>
                        {cargando ? <Spinner size="sm" className="mr-2" /> : null}
                        Enviar
                    </Button>
                </ModalFooter>
            )}
        </Modal>
    </>
}

const ModalComentarios = ({ evento, Servicio, close }) => {
    const columns = [
        { key: "fecha", name: "Fecha", formatter: ({ value }) => moment(value).format("DD/MM/YYYY hh:mm") },
        { key: "tipo", name: "Origen", formatter: ({ value }) => value ? "Cliente" : "Empresa" },
        { key: "observacion", name: "Observacion" }
    ]
    return <Modal scrollable size="lg" wrapClassName="asyntec-portal-clientes" isOpen={evento} toggle={close}>
        <ModalHeader className="titulo-modal" close={<button style={{ color: "#fff" }} className="close" onClick={close}>&times;</button>}>
            Comentarios Requerimiento {evento?.numero}
        </ModalHeader>
        <ModalBody style={{ whiteSpace: "nowrap" }}>
            {Servicio.Empresa?.otros?.Requerimientos?.Reiteracion && evento?.cerrado === false ?
                <CreaReiteracion Servicio={Servicio} evento={evento} />
                : null}
            {/* Vista para escritorio y tablet */}
            <div className="d-none d-md-block">
                <GriddleCasero
                    data={evento?.comentarios}
                    columns={columns}
                />
            </div>

            {/* Vista para móviles */}
            <div className="d-md-none">
                {evento?.comentarios?.length ? (
                    evento.comentarios.map((item, index) => (
                        <Card key={index} className="mb-3">
                            <CardBody>
                                <p><strong>Fecha:</strong> {moment(item.fecha).format("DD/MM/YYYY hh:mm")}</p>
                                <p><strong>Origen:</strong> {item.tipo ? "Cliente" : "Empresa"}</p>
                                <p><strong>Observación:</strong> {item.observacion}</p>
                            </CardBody>
                        </Card>
                    ))
                ) : (
                    <p className="text-center text-muted">No se encontraron comentarios.</p>
                )}
            </div>
        </ModalBody>
        <ModalFooter>
        </ModalFooter>
    </Modal>
}

const CreaRequerimiento = ({ Servicio, requerimientos, onExito, onReiterar }) => {
    const [tipos, setTipos] = useState([])
    const [campos, setCampos] = useState([])
    const [tipoSeleccionado, setTipoSeleccionado] = useState()
    const [abre, setAbre] = useState()
    const [folioGenerado, setFolioGenerado] = useState(null)
    const [cargando, setCargando] = useState(false)

    useEffect(() => {
        if (abre) {
            (async () => {
                try {
                    if (!tiposRequerimientos.data) tiposRequerimientos.data = await API.Call(`Consulta/${Servicio.empresa}/Requerimientos/Campos/${Servicio.idServicio}`)
                    setTipos(tiposRequerimientos.data.tipos)
                    setCampos(tiposRequerimientos.data.campos)
                } catch (e) {
                    console.error("Error cargando campos", e)
                }
            })()
        }
    }, [abre])

    const seleccionarTipo = (id) => {
        const t = tipos.find(e => e.id_tipo_evento == id)
        if (t) {
            const reqExistente = (requerimientos || []).find(r => r.tipo_evento == id && r.cerrado === false);
            if (reqExistente) {
                if (window.confirm("Ya existe un requerimiento activo con el tipo seleccionado. ¿Desea agregar un comentario al requerimiento existente?")) {
                    handleClose();
                    if (onReiterar) onReiterar(reqExistente);
                    return;
                }
            }
            const fullCampos = t.fieldIds.map(fid => ({ ...campos.find(c => c.FieldId == fid), Value: "", OptionKey: "" }))
            setTipoSeleccionado({ ...t, campos: fullCampos, comentario: "" })
        } else {
            setTipoSeleccionado(null)
        }
    }

    const handleClose = () => {
        setAbre(false);
        setFolioGenerado(null);
        setTipoSeleccionado(null);
    };

    return <>
        <div className="text-right mb-3">
            <Button color="primary" size="sm" onClick={() => setAbre(true)}>
                <i className="fa fa-plus mr-2" /> Nuevo Requerimiento
            </Button>
        </div>

        <Modal scrollable size="lg" wrapClassName="asyntec-portal-clientes" isOpen={abre} toggle={handleClose}>
            <ModalHeader className="titulo-modal" close={<button style={{ color: "#fff" }} className="close" onClick={handleClose}>&times;</button>}>
                Nuevo Requerimiento
            </ModalHeader>
            <ModalBody>
                {folioGenerado ? (
                    <RequerimientoExito folio={folioGenerado} onVolver={handleClose} mensajeVolver="Cerrar" />
                ) : (
                    <>
                        <FormGroup>
                            <Label for="tipo">Tipo de Requerimiento *</Label>
                            <Input type="select" id="tipo" value={tipoSeleccionado?.id_tipo_evento || ""} onChange={e => seleccionarTipo(e.target.value)}>
                                <option value="">Seleccione un tipo...</option>
                                {tipos.map(t => <option key={t.id_tipo_evento} value={t.id_tipo_evento}>{t.subclasificacion}</option>)}
                            </Input>
                        </FormGroup>

                        {tipoSeleccionado && <>
                            <FormGroup>
                                <Label className={!tipoSeleccionado.comentario ? "text-danger" : ""} for="desc">Descripción / Comentario *</Label>
                                <Input type="textarea" name="comentario" value={tipoSeleccionado.comentario} onChange={e => setTipoSeleccionado({ ...tipoSeleccionado, comentario: e.target.value })} id="desc" />
                            </FormGroup>

                            {_.map(_.sortBy(_.groupBy(tipoSeleccionado.campos || [], cp => cp.Categoria), c => c[0].Categoria), cat => {
                                return <Card className="mb-3" key={cat[0].Categoria}>
                                    <CardHeader className="titulo-modal p-2">{cat[0].Categoria}</CardHeader>
                                    <CardBody>
                                        {cat.filter(cf => cf.FieldId > -2).map(cf => {
                                            return <InputCustomFieldForm
                                                key={cf.FieldId}
                                                customField={cf}
                                                setCustomFieldValue={e => {
                                                    var camposClone = [...tipoSeleccionado.campos]
                                                    var index = camposClone.findIndex(f => f.FieldId == cf.FieldId)
                                                    camposClone[index] = { ...camposClone[index], Value: e, OptionKey: e }
                                                    setTipoSeleccionado({ ...tipoSeleccionado, campos: camposClone })
                                                }} />
                                        })}
                                    </CardBody>
                                </Card>
                            })}
                        </>}
                    </>
                )}
            </ModalBody>
            {!folioGenerado && (
                <ModalFooter>
                    <Button color="primary" disabled={cargando || !tipoSeleccionado || !tipoSeleccionado.comentario || tipoSeleccionado.campos?.some(o => o.Mandatory && !o.Value)} onClick={() => {
                        setCargando(true)
                        API.Call(`Consulta/${Servicio.empresa}/Requerimientos/${Servicio.idServicio}/Agregar`, {
                            tipo_evento: tipoSeleccionado.id_tipo_evento,
                            campos: tipoSeleccionado.campos.map(d => ({ Value: d.Value, OptionKey: d.OptionKey, FieldId: d.FieldId })),
                            comentario: tipoSeleccionado.comentario
                        }).then(res => {
                            setCargando(false)
                            setFolioGenerado(res || { Folio: 'Generado' });
                            if (onExito) onExito()
                        }).catch(() => {
                            setCargando(false)
                        })
                    }}>
                        {cargando ? <Spinner size="sm" className="mr-2" /> : null}
                        Enviar
                    </Button>
                </ModalFooter>
            )}
        </Modal>
    </>
}

const Requerimientos = (props) => {

    const [requerimientos, setRequerimientos] = useState([])
    const [evento, setEvento] = useState()

    const columns = [
        { key: "numero", name: "Numero" },
        { key: "categoria", name: "Categoría" },
        { key: "clasificacion", name: "Clasificación" },
        { key: "subclasificacion", name: "Subclasificación" },
        { key: "cerrado", name: "Estado", formatter: ({ value, griddleKey, rowData }) => value ? "Cerrado" : "Abierto" },
        { key: "creacion", name: "Fecha Creacion", formatter: ({ value }) => moment(value).format("DD/MM/YYYY") },
        { key: "estimado_solucion", name: "Fecha Esperada Solución", formatter: ({ value }) => value ? moment(value).format("DD/MM/YYYY") : null },
        { key: "solucion", name: "Fecha Solución", formatter: ({ value }) => value ? moment(value).format("DD/MM/YYYY") : null },
        { key: "comentarios", name: " ", formatter: ({ rowData }) => <Button onClick={() => setEvento(rowData)} size="sm">Comentarios</Button> },
    ];

    const refresh = () => {
        if (props.Servicio.idServicio) {
            API.Call(`Consulta/${props.Servicio.empresa}/Requerimientos/${props.Servicio.idServicio}`).then(ev => {
                setRequerimientos(ev.map(e => ({ ...e, numero: `${e.localidad}-${e.folio}` })))
            });
        }
    }

    useEffect(() => {
        if (!props.Servicio.idServicio) {
            props.history.replace("/administra")
        } else {
            refresh();
        }

    }, [])
    return <>
        <Row>
            <Col sm={12} className="bordeIzquierdo">
                <CreaRequerimiento Servicio={props.Servicio} requerimientos={requerimientos} onExito={refresh} onReiterar={(req) => setEvento(req)} />
                {/* Vista para escritorio y tablet */}
                <div className="d-none d-md-block">
                    <GriddleCasero
                        data={requerimientos}
                        columns={columns}
                    />
                </div>

                {/* Vista para móviles */}
                <div className="d-md-none">
                    {requerimientos.length > 0 ? (
                        requerimientos.map((item, index) => (
                            <Card key={index} className="mb-3">
                                <CardBody>
                                    <p><i className="fa fa-ticket mr-2" /><strong>Número:</strong> {item.numero}</p>
                                    <p><i className="fa fa-tag mr-2" /><strong>Categoría:</strong> {item.categoria}</p>
                                    <p><i className="fa fa-tags mr-2" /><strong>Clasificación:</strong> {item.clasificacion}</p>
                                    <p><i className="fa fa-bookmark mr-2" /><strong>Subclasificación:</strong> {item.subclasificacion}</p>
                                    <p><i className={`fa ${item.cerrado ? 'fa-check-circle text-success' : 'fa-hourglass-half text-warning'} mr-2`} /><strong>Estado:</strong> {item.cerrado ? "Cerrado" : "Abierto"}</p>
                                    <p><i className="fa fa-calendar-plus-o mr-2" /><strong>Fecha Creación:</strong> {moment(item.creacion).format("DD/MM/YYYY")}</p>
                                    <p><i className="fa fa-calendar-check-o mr-2" /><strong>Fecha Esperada Solución:</strong> {item.estimado_solucion ? moment(item.estimado_solucion).format("DD/MM/YYYY") : 'N/A'}</p>
                                    <p><i className="fa fa-calendar-check-o mr-2" /><strong>Fecha Solución:</strong> {item.solucion ? moment(item.solucion).format("DD/MM/YYYY") : 'N/A'}</p>
                                    <Button onClick={() => setEvento(item)} size="sm"><i className="fa fa-comments-o mr-2" />Comentarios</Button>
                                </CardBody>
                            </Card>
                        ))
                    ) : (
                        <p className="text-center text-muted">No se encontraron requerimientos.</p>
                    )}
                </div>
                <ModalComentarios Servicio={props.Servicio} evento={evento} close={() => setEvento()} />
            </Col>
        </Row>
    </>
}


export default withRouter(Requerimientos);